import api from './config';

export const getMeApi = async () => {
  try {
    const response = await api.get('/auth/me');
    return response.data;
  } catch (error: any) {
    return { error: true, status: error.response?.status, message: error.message };
  }
};

export const webRefreshApi = async () => {
  try {
    const response = await api.post('/auth/web/refresh');
    return response.data;
  } catch (error: any) {
    return { error: true, status: error.response?.status, message: error.message };
  }
};

export const webLogoutApi = async () => {
  try {
    await api.post('/auth/web/logout');
    return { success: true };
  } catch (error: any) {
    return { error: true, message: error.message };
  }
};
